import { render, staticRenderFns } from "./_price-analysis.tab.vue?vue&type=template&id=56599794&scoped=true&"
import script from "./_price-analysis.tab.vue?vue&type=script&lang=js&"
export * from "./_price-analysis.tab.vue?vue&type=script&lang=js&"
import style0 from "./_price-analysis.tab.vue?vue&type=style&index=0&id=56599794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56599794",
  null
  
)

export default component.exports